/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
  Link,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs, { Dayjs } from "dayjs";
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import "./style.css";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
const FleetDailyReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState<any>();
  const [userDetailListData, setUserDetailListData] = useState<any[]>([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [paymentSchedule, setPaymentSchedule] = useState<string>("");
  const [openExpiryDialog, setOpenExpiryDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [updatedExpiry, setUpdatedExpiry] = useState<Dayjs | null>(null);
  const [remarks, setRemarks] = useState("");

  const rowsPerPage = 10;
  const pageRange = 5;
  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#3b3b3b",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const paymentLabels: Record<string, string> = {
    FULL_UPFRONT: "Full amount received",
    SPLIT_WEEKLY: "Partial amount received",
  };
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  const navigate = useNavigate();
  function getStatusColor(status: boolean) {
    if (status === true) {
      return "#CFFFEF"; // active
    } else if (status === false) {
      return "#FFD7D2"; // inactive
    }
    return "";
  }

  function getStatusTextColor(status: boolean) {
    if (status === true) {
      return "#05B97D"; // active
    } else if (status === false) {
      return "#F94932"; // inactive
    }
    // Default text color
    return "";
  }

  function getStatusText(status: boolean): string {
    if (status === true) {
      return "Active";
    } else if (status === false) {
      return "Inactive";
    }
    // Default status text
    return "";
  }

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };

  const handleClearSearch = () => {
    setSearchValInput("");
  };
  const handleCreateuser = () => {
    //   setUserId(uid);
    navigate("/createUser");
  };
  const handleExtendPlan = () => {
    if (!selectedUser || !updatedExpiry) return;

    const payload = {
      userId: selectedUser.userId,
      updatedExpirationTime: updatedExpiry.format("YYYY-MM-DDTHH:mm:ss"),
      remarks: remarks || "Plan extended",
    };

    ZyppLiteApi.api
      ?.extendRentalPlan(payload)
      .then((res: any) => {
        console.log("API response:", res);

        if (res?.data?.code === 2000) {
          setSnackbarMessage("Expiry date updated successfully");
          setSnackbarSeverity("success");
          setShowErrorSnackbar(true);
          setOpenExpiryDialog(false);
          fetchUserData();
        } else {
          throw new Error(res?.data?.message || "Unknown error");
        }
      })
      .catch((error: any) => {
        console.error("Extend plan error:", error);
        setSnackbarMessage("Failed to update expiry date");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      });

  };

  const fetchUserData = () => {
    ZyppLiteApi.api
      ?.userDeatailList(searchValInput, page, rowsPerPage)
      .then((response) => {
        if (response.data.usersDetails.length > 0) {
          setUserDetailListData(response.data.usersDetails);
          setTotalCount(response.data.total);
        } else {
          setUserDetailListData([]);
          setTotalCount(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };
  useEffect(() => {
    fetchUserData();
  }, [page, rowsPerPage, searchValInput]);

  const edituser = (item: any) => {
    navigate("/editUser", { state: item });
  };

  const handlePlanStatusUpdate = (userId: number, planStatus: string,) => {
  const payload: any = {
  userId,
  planStatus,
};

if (selectedPlan?.selectedPaymentSchedule !== null) {
  payload.paymentSchedule = paymentSchedule;
}

    ZyppLiteApi.api
      ?.verifyRentalPlan(payload)
      .then((response: any) => {
        if (response?.code === 2000) {
          setSnackbarMessage("Plan status updated successfully");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("success");
          setAnchorEl(null); // Close popper
          setSelectedPlan(null);
          fetchUserData();
        } else {
          setSnackbarMessage(response?.message || "Plan update failed");
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("Plan status update error:", error);
        setSnackbarSeverity("error");
        setSnackbarMessage(
          error.response.data?.message || "Failed to update. Please try again."
        );
        setShowErrorSnackbar(true);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (anchorEl && !anchorEl.contains(event.target as Node)) {
        setAnchorEl(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl]);

  return (
    <div className="p-10">
      <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl">
        <div className="w-full">
          <Grid container spacing={5} className="w-full flex justify-between ">
            <Grid item md={3}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                  Rider Details List
                </h2>
              </div>
            </Grid>
            <Grid item md={9}>
              <div className="flex mr-4">
                <div className="flex w-full justify-end">
                  <div className="mr-3">
                    <TextField
                      placeholder="Search Vehicle No, Mobile No"
                      id="outlined-basic"
                      variant="outlined"
                      onChange={(search: any) =>
                        setSearchValInput(search.target.value)
                      }
                      value={searchValInput}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={handleClearSearch}
                          >
                            <ClearIcon style={{ cursor: "pointer" }} />
                          </InputAdornment>
                        ),
                        style: {
                          height: "40px",
                          borderRadius: "25px",
                          width: "350px",
                        },
                      }}
                    // onKeyDown={handleKeyPress}
                    />
                  </div>

                  <div>
                    <Link
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        handleCreateuser();
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#000",
                          padding: "5px 18px",
                          color: "#fff",
                          borderRadius: "40px",
                          width: "100%",
                          textTransform: "none",
                          fontSize: "16px",
                        }}
                      >
                        <AddIcon /> Add Rider
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          <hr className="my-4" />

          <TableContainer>
            {!userDetailListData ? ( // Check if API response is still undefined (loading)
              <LinearProgress />
            ) : typeof userDetailListData === "string" ? ( // If API returns "No Data Found" as a string
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : userDetailListData.length === 0 ? ( // If the array is empty
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Vehicle No
                    </TableCell>

                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      Mobile
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 100 }}
                    >
                      Kyc status
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      Plan Status
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Plan Selected
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 160 }}
                    >
                      Expiry Date/Time
                    </TableCell>
                     <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 160 }}
                    >
                     Dues Pending
                    </TableCell>

                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 100 }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 80 }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userDetailListData.map((item: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.vehicleNo ? item.vehicleNo : "_"}
                      </TableCell>

                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {[item.firstName, item.lastName].filter(Boolean).join(" ")}
                      </TableCell>

                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.mobile}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.kycStatus ? item.kycStatus : "_"}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                          {item.planStatus ? item.planStatus : "_"}
                        
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        <p
                          style={{
                            color:
                              item.planStatus === "PENDING"
                                ? "#f5be08"
                                : item.planStatus === "APPROVED"
                                  ? "#06B681"
                                  : item.planStatus === "REJECTED"
                                    ? "red"
                                    : item.planStatus === "EXPIRED"
                                      ? "blue"
                                      : "inherit",
                            fontWeight: "bold",
                          }}
                        >
                          {item.planSelected ? (
                            <>
                              <Tooltip title={item.planStatus} arrow>
                                <span style={{ fontWeight: "bold" }}>
                                  {item.planSelected}
                                </span>
                              </Tooltip>
                              <InfoIcon
                                style={{
                                  cursor:
                                    item.planStatus === "PENDING"
                                      ? "pointer"
                                      : "not-allowed",
                                  color:
                                    item.planStatus === "PENDING"
                                      ? "#f5be08"
                                      : item.planStatus === "APPROVED"
                                        ? "#06B681"
                                        : item.planStatus === "REJECTED"
                                          ? "red"
                                          : item.planStatus === "EXPIRED"
                                            ? "blue"
                                            : "inherit",

                                  display: item.planStatus === "PENDING" ? 'inline-block' : 'none',
                                }}
                                onClick={() => {
                                  if (item.planStatus === "PENDING") {
                                    setSelectedPlan(item);
                                    setPaymentSchedule(item.selectedPaymentSchedule); // ✅ default selected
                                    setOpenDialog(true);
                                  }
                                }}
                              />
                            </>
                          ) : (
                            "_"
                          )}
                        </p>
                      </TableCell>

                      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
                        {item.expirationTime
                          ? item.expirationTime.replace("T", " ")
                          : "_"}

                        <EditIcon
                          sx={{
                            ml: 1,
                            fontSize: 18,
                            cursor: "pointer",
                            color: "#00CD5B",
                          }}
                          onClick={() => {
                            setSelectedUser(item);
                            setUpdatedExpiry(
                              item.expirationTime ? dayjs(item.expirationTime) : null
                            );
                            setRemarks("");
                            setOpenExpiryDialog(true);
                          }}
                        />
                      </TableCell>

 <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                       {item.leftAmount ? item.leftAmount : "_"}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        <span
                          style={{
                            backgroundColor: getStatusColor(item.isActive),
                            color: getStatusTextColor(item.isActive),
                            paddingInline: "18px",
                            paddingBlock: "4px",
                            borderRadius: "14px",
                            width: "100px",
                            font: "Rubik",
                            fontSize: "14px",
                          }}
                        >
                          {getStatusText(item.isActive)}
                        </span>
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        <img
                          src={"/assets/edit-icon.svg"}
                          alt="edit"
                          onClick={() => edituser(item)}
                          style={{
                            cursor: "pointer",
                            display: "block",
                            margin: "auto",
                          }}
                        />
                        {/* {item.isActive === true ? ( */}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>

          <div className="pl-2 pt-4 pb-2 pr-16">
            <div
              className="pagination"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <button
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 0}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginRight: "6px",
                  }}
                >
                  {"<"}
                </button>
                {renderPageNumbers()}
                <button
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= pageCount - 1}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginLeft: "6px",
                  }}
                >
                  {">"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={showErrorSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowErrorSnackbar(false)}
      >
        <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
      </Snackbar>
      <Dialog
        open={openExpiryDialog}
        onClose={() => setOpenExpiryDialog(false)}
        fullWidth
        maxWidth="sm"
        scroll="paper"
        PaperProps={{
          sx: {
            marginTop: "20px",
            alignSelf: "flex-start",
          },
        }}
      >

        <DialogTitle>Update Expiry Date & Time</DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
          <DateTimePicker
            label="Expiry Date & Time"
            value={updatedExpiry}
            onChange={(newValue) => setUpdatedExpiry(newValue)}
            sx={{ width: "100%", mb: 2 }}
          />

          <TextField
            label="Remarks"
            fullWidth
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Reason for extension"
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenExpiryDialog(false)}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleExtendPlan}
            sx={{
              backgroundColor: "#1976d2",
              textTransform: "none",
              borderRadius: "20px",
              px: 3,
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>{selectedPlan?.planSelected}</DialogTitle>
        <DialogContent>
           {selectedPlan?.selectedPaymentSchedule === null && (
 <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
           Do you want to approve or reject the plan for user: {selectedPlan?.userId} ?
          </Typography>
           )}
            {selectedPlan?.selectedPaymentSchedule !== null && (
          <div>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Amount chosen by Rider:{" "}
            <b>{selectedPlan?.chosenAmount}</b>
          </Typography>

       
       

  <TextField
    select
    label="Payment Mode"
    value={paymentSchedule}
    onChange={(e) => setPaymentSchedule(e.target.value)}
    fullWidth
    SelectProps={{ native: true }}
    sx={{ mt: 1 }}
  >
    {selectedPlan?.paymentScheduleEnum?.map((option: string) => (
      <option key={option} value={option}>
        {paymentLabels[option] || option.replaceAll("_", " ")}
      </option>
    ))}
  </TextField>

</div>
)}
        </DialogContent>
        <DialogActions >
          <Button
            onClick={() => {
              if (selectedPlan) {
                handlePlanStatusUpdate(selectedPlan.userId, "APPROVED");
              }
              setOpenDialog(false);
            }}
            variant="contained"
            style={{
              backgroundColor: "#05B97D",
              color: "#fff",
              textTransform: "none",
              borderRadius: "20px",
              padding: "5px 25px",
              marginBottom: "10px"
            }}
          >
            Accept
          </Button>
          <Button
            onClick={() => {
              if (selectedPlan) {
                handlePlanStatusUpdate(selectedPlan.userId, "REJECTED");
              }
              setOpenDialog(false);
            }}
            variant="contained"
            style={{
              backgroundColor: "#F94932",
              color: "#fff",
              textTransform: "none",
              borderRadius: "20px",
              padding: "5px 25px",
              marginBottom: "10px"
            }}
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FleetDailyReport;
